import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InspectionType } from '../../_objects/InspectionType';
import { ApiService } from '../base/api-base.service';
import { InspectionTypeContractService } from '../interfaces/inspection-type-contract.service';
import { NetworkStatusService } from '../network-status.service';
import { InspectionTypeOfflineService } from '../offline/inspection-type-offline.service';
import { InspectionTypeOnlineService } from '../online/inspection-type-online.service';

@Injectable({
  providedIn: 'root'
})
export class InspectionTypeService extends ApiService<InspectionTypeContractService> implements InspectionTypeContractService {

  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: InspectionTypeOfflineService,
    protected onlineService: InspectionTypeOnlineService) {
    super(networkStatusService, offlineService, onlineService);
  }

  getInspectionTypes(): Observable<InspectionType> {
    return this.service.getInspectionTypes();
  }
}
